<template>
  <div class="builderDialog">
    <el-dialog
      :visible.sync="dialogOpen"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="40%"
      center
    >
      {{ dialogBuilderText }}
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "BulderDialog",
  computed: {
    dialogOpen: {
      get() {
        return this.$store.state.Dialog.dialogBuilder;
      },
      set(value) {
        this.$store.commit("Dialog/setData", {
          label: "dialogBuilder",
          data: value,
        });
      },
    },
    dialogBuilderText() {
      return this.$store.state.Dialog.dialogBuilderText;
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/helpers/mixin";
@import "../../assets/styles/helpers/variables";
.builderDialog {
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog {
    margin-top: 30rem !important;
    width: 49rem;
    @include below($md) {
      width: 90%;
      margin-top: 10rem !important;
    }
  }
}
</style>
